export interface CaptchaData {
  captchaId: string;
  captchaImage: string;
  requiresCaptcha: true;
  reutrnUrl: string;
}
export interface RedirectData {
  url: string;
}

export function hasCaptchaInfo(data: any): data is CaptchaData {
  return (
    data &&
    typeof data.captchaId === "string" &&
    typeof data.captchaImage === "string" &&
    typeof data.requiresCaptcha === "boolean"
  );
}

export function hasRedirectInfo(data: any): data is RedirectData {
  return data && data.url && typeof data.url === "string";
}

export const redirectToExternal = (externalUrl: string) => {
  window.location.href = `${externalUrl}`;
};
